module.exports = __webpack_public_path__ + "img/i_main_my_wifi.4a889dac.svg";